<template>
  <component :is="component" />
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import Sunburst from '@/components/public/Visualisations/Sunburst/Sunburst.vue'
import CustomVisualisation from '@/components/public/Visualisations/CustomVisualisation/CustomVisualisation.vue'
import MobileBubbles from '@/components/public/Visualisations/Bubbles/MobileBubbles.vue'
import BubblesV2 from '@/components/public/Visualisations/BubblesV2/BubblesV2.vue'
import MapWrapper from '@/components/public/Visualisations/TheMap/MapWrapper.vue'
import NestedBubbles from '@/components/public/Visualisations/NestedBubbles/NestedBubbles.vue'
import XYBubbles from '@/components/public/Visualisations/XYBubbles/XYBubbles.vue'
import { useFeaturesStore } from '@/store/common/features'

@Component
export default class MobileVisualisationView extends Vue {
  get useBubblesV2() {
    return useFeaturesStore().useBubblesV2
  }

  get component() {
    const { isBubbles, isSunburst, isCustom, isMap, isNestedBubbles, isXYBubbles } =
      this.$typedStore.activeVisualisation
    if (isCustom) return CustomVisualisation
    if (isMap) return MapWrapper
    if (isBubbles && this.useBubblesV2) return BubblesV2
    if (isBubbles) return MobileBubbles
    if (isSunburst) return Sunburst
    if (isNestedBubbles) return NestedBubbles
    if (isXYBubbles) return XYBubbles
    return null
  }
}
</script>
